import { logJqueryMigrationErrors } from '../../../src/shared/helpers/jquery-migrate';

export function StateChangeEventsRun(
    $rootScope,
    $state,
    $timeout,
    $location,
    $window,
    $log,
    Page,
    PAGE_LAYOUT,
    ACCESS_LEVEL,
    SeedData,
    BdStorage,
    BASE_PATH,
    BASE_PATH_PUBLIC,
    Notify,
    HTTP_STATUS_CODES,
    IS_PRODUCTION,
    $anchorScroll,
    Settings,
    SiteChromeService
) {
    let newState,
        oldState;

    // 1 is page reload https://developer.mozilla.org/en-US/docs/Web/API/Navigation_timing_API
    //const navigationTypeReload = 1;

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
        newState = toState;
        oldState = fromState;
    });

    $rootScope.$on('$stateNotFound', function(event, unfoundState) {
        $log.log(`could not resolve angular route. ${unfoundState} state not found`);
        $state.go('404');
    });

    // By default, ui-router won't throw exceptions if there are exceptions in resolve blocks. See https://github.com/angular-ui/ui-router/issues/469
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        const aux = (error && error.detail) || error || { status: HTTP_STATUS_CODES.InternalServerError };
        switch (aux.status) {
            case HTTP_STATUS_CODES.Forbidden: // forbidden
                $state.go('noaccess');
                break;
            case HTTP_STATUS_CODES.BadRequest:
            case HTTP_STATUS_CODES.NotFound:
                $state.go('404');
                break;
            default: {
                const errorDetails = error instanceof Error ? error.toString() : JSON.stringify(error);
                $log.error(`Error during state change from ${fromState.name || 'init'} to ${toState.name}. Error details: \n${errorDetails}`);
                break;
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState) {
        const bodyClasses = [];

        // If the state has a custom data object
        if (toState.data) {
            // Push all classes in optional attribute bodyClass into an array
            if (toState.data.bodyClass) {
                toState.data.bodyClass.split(' ').forEach(function(item) {
                    bodyClasses.push(item);
                });
            }

            // Apply the class(es). This is done in this file because if the listener
            // for $stateChangeSuccess was in the Page service, it would be set too
            // late when navigating via URL and the class wouldn't be updated.
            Page.updateBodyClasses(bodyClasses);
        } else {
            // otherwise remove all that have been applied.
            Page.removeAppliedBodyClasses();
        }

        if (toState.data && toState.data.layout) {
            Page.setLayout(toState.data.layout);
        } else {
            Page.setLayout(PAGE_LAYOUT.Standard);
        }

        const hideSiteChrome = toState.data ? !!toState.data.hideSiteChrome : false;
        Page.setSiteChromeVisibility(hideSiteChrome);
        SiteChromeService.setVisibility(!hideSiteChrome);

        Notify.displayConfirmationMessage();

        if (!fromState || !fromState.name || toParams.showLoaderOnStateChange) {
            Page.setLoaded();
        }

        if (!IS_PRODUCTION) {
            logJqueryMigrationErrors();
        }
    });

    function isSameState() {
        if (newState && oldState) {
            return newState === oldState;
        }

        return true;
    }

    function shouldUpdateReturnUrl(newUrl, oldUrl, referrer, currentReturnUrl) {
        if (isSameState()) {
            return false;
        }
        return (referrer && currentReturnUrl && referrer.toLowerCase() !== currentReturnUrl.toLowerCase())
                || !currentReturnUrl
                || (newUrl && oldUrl && newUrl.toLowerCase() !== oldUrl.toLowerCase());
    }

    function getUpdatedReturnUrl(newUrl, oldUrl, referrer, returnUrl) {
        // if previous page was an aspx page, return that, else return the previous angular page
        // because docoument.referrer does not catch changes in angular state
        if (newUrl && oldUrl && newUrl.toLowerCase() !== oldUrl.toLowerCase()) {
            return oldUrl;
        }

        return returnUrl || referrer;
    }

    function updateReturnUrl(newUrl, oldUrl) {
        const loginUrl = `${$window.location.host}${BASE_PATH_PUBLIC}/authentication/login`;
        const currentReturnUrl = BdStorage.sessionstorage.get('returnUrl');
        const {referrer} = document;
        const protocol = $location.protocol();

        // If we came from login prevent infinite loop. If they revisited the page (non-refresh), hit back, or it is a new tab/window, we can't assume anything
        if ((oldUrl && oldUrl.toLowerCase().indexOf(loginUrl.toLowerCase()) === -1) && shouldUpdateReturnUrl(newUrl, oldUrl, referrer, currentReturnUrl)) {
            BdStorage.sessionstorage.set('returnUrl', getUpdatedReturnUrl(newUrl, oldUrl, referrer, currentReturnUrl));
        } else if ((referrer && referrer.toLowerCase().indexOf(loginUrl.toLowerCase()) > -1) || (!referrer && !currentReturnUrl)) {
            BdStorage.sessionstorage.set('returnUrl', `${protocol}://${$window.location.host}${BASE_PATH}`);
        }
    }

    $rootScope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl) {
        updateReturnUrl(newUrl, oldUrl);
        $timeout(() => {
            $anchorScroll();
        }, 200);
    });
}
StateChangeEventsRun.$inject = [
    '$rootScope',
    '$state',
    '$timeout',
    '$location',
    '$window',
    '$log',
    'Page',
    'PAGE_LAYOUT',
    'ACCESS_LEVEL',
    'SeedData',
    'BdStorage',
    'BASE_PATH',
    'BASE_PATH_PUBLIC',
    'Notify',
    'HTTP_STATUS_CODES',
    'IS_PRODUCTION',
    '$anchorScroll',
    'Settings',
    'SiteChromeService',
];
